import * as t from "io-ts"

/** A ts-io value representing the result returned from the GET device reference endpoint */
export const DeviceReference = t.type({
    deviceID: t.string,
    deviceRef: t.string,
})

/** A type derived from the DeviceRefence ts-io value representing
 * the result returned from the GET device reference endpoint */
export type TDeviceRef = t.TypeOf<typeof DeviceReference>
